
const DashboardsComingSoon = () => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center gap-8">
      <img src="dashboards-coming-soon.svg" className="h-96" draggable="false" />

      <div className="flex flex-col items-center gap-1">
        <p className="text-xl font-bold">
          Em breve teremos uma nova funcionalidade de dashboard
        </p>
      </div>
    </div>
  );
}

export default DashboardsComingSoon;
